import React from 'react';
import { useStyles } from './styles';
import { Box, Typography, Button, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useHistory } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const AccountRequired = (props) => {

  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} open={true} onClose={props.handleClose}>
      <Box className={classes.root}>
       
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Sign In Required</Typography>
        </Box>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusSubTitle}>This action requires you to sign in to your MyLoanWeb account. Would you like to sign in now?</Typography>
          
          <Box className={classes.footerSection}>
            <Grid container>
                <Grid item xs={6} md={6} className={classes.pr35}>
                    <Box className={classes.cancelBtnBox}>
                    <Button
                        className={classes.cancelBtn}
                        variant="outlined"
                        onClick={props.handleClose}
                    >Cancel</Button>
                    </Box>
                </Grid>
                <Grid item xs={6} md={6} className={classes.pl35}>
                    <Button
                      className={classes.saveBtn}
                      variant="contained"
                      onClick={() => history.push('/SignIn')}
                      color="primary">Sign In
                    </Button> 
                </Grid>
            </Grid>
          </Box>

        </Box>
      </Box>
    </Dialog>
  )
}
